import { api_request } from '../axios_client';
import { handleError } from '../common';
import * as Constants from '../constants';

const asnFiltersGet = async (signal, options) => {
  const resourcePath = `${Constants.PATH.ASN.filters}`;

  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      options,
      signal
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};
const nullRemover = (body) => {
  const newBody = {};
  Object.keys(body).forEach((key) => {
    if (Array.isArray(body[key])) {
      newBody[key] = body[key].filter((value) => !!value)?.[0]?.split(',');
    } else {
      newBody[key] = body[key];
    }
  });
  return newBody;
};

const asnListGet = async (params, signal, options) => {
  const resourcePath = `${Constants.PATH.ASN.list}`;
  const queryParams = params.params;
  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      params: queryParams,
      data: options,
      options,
      signal
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const asnSummaryGet = async (params, signal, options) => {
  const resourcePath = `${Constants.PATH.ASN.summary}`;
  const queryParams = params.params;
  const { body } = params;
  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      params: queryParams,
      data: options,
      options,
      signal
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

// packing list sample
const asnSkuSampleGet = async (id, options) => {
  const resourcePath = `${Constants.PATH.ASN.skuSample}`;

  try {
    const res = await api_request({
      methodType: 'get',
      params: { id },
      resourcePath,
      options
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

// edit - ASN
const asnIdDetailsGet = async (id, options) => {
  const resourcePath = `${Constants.PATH.ASN.asn}/${id}${Constants.PATH.ASN.idDetails}`;

  try {
    const res = await api_request({ methodType: 'get', resourcePath, options });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const asnIdValidatePackingListGet = async (id, options) => {
  const resourcePath = `${Constants.PATH.ASN.asn}/${id}${Constants.PATH.ASN.validatePackingList}`;

  try {
    const res = await api_request({ methodType: 'get', resourcePath, options });
    return res;
  } catch (err) {
    handleError(err);
  }
};

// post - validate packing list on upload
const asnIdValidatePackingListOnUploadPost = async (data, id, options) => {
  const resourcePath = `${Constants.PATH.ASN.asn}/${id}${Constants.PATH.ASN.validatePackingListOnUpload}`;

  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      data,
      options
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

// sample download
const asnIdSampleCommentDownloadGet = async (id, options) => {
  const resourcePath = `${Constants.PATH.ASN.asn}/${id}${Constants.PATH.ASN.sampleCommentDownload}`;

  try {
    const res = await api_request({ methodType: 'get', resourcePath, options });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const asnIdUpdatePut = async (data, id, options) => {
  const resourcePath = `${Constants.PATH.ASN.asn}/${id}${Constants.PATH.ASN.update}`;

  try {
    const res = await api_request({
      methodType: 'put',
      resourcePath,
      data,
      options
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const asnPost = async (data, options) => {
  const resourcePath = `${Constants.PATH.ASN.asnNew}`;

  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      data,
      options
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

// file submit
const asnIdFilesSubmitPost = async (data, id, options) => {
  const resourcePath = `${Constants.PATH.ASN.asn}/${id}${Constants.PATH.ASN.filesSubmit}`;

  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      data,
      options
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

// comments upload
const asnIdCommentsUploadPost = async (payload, options) => {
  const { remarks, comment_type, id, revised_delivery_date, file, lr_number, dispatch_date, tracking_link } = payload;
  const resourcePath = `${Constants.PATH.ASN.asn}/${id}${Constants.PATH.ASN.commentsUpload}`;

  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      params: {
        remarks,
        comment_type,
        revised_delivery_date: revised_delivery_date || undefined,
        lr_number,
        dispatch_date,
        tracking_link
      },
      data: { file },
      options
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

// send for approval
const asnIdEventEventPut = async (id, event, options) => {
  const resourcePath = `${Constants.PATH.ASN.asn}/${id}${Constants.PATH.ASN.event}/${event}`;

  try {
    const res = await api_request({ methodType: 'put', resourcePath, options });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const asnIdUpdateFieldsPut = async (data, id, options) => {
  const resourcePath = `${Constants.PATH.ASN.asn}/${id}${Constants.PATH.ASN.updateFields}`;

  try {
    const res = await api_request({
      methodType: 'put',
      resourcePath,
      data,
      options
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const asnIdRequiredFilesGet = async (id, options) => {
  const resourcePath = `${Constants.PATH.ASN.asn}/${id}${Constants.PATH.ASN.requiredFiles}`;

  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      options
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

export {
  asnFiltersGet,
  asnListGet,
  asnSummaryGet,
  asnIdDetailsGet,
  asnIdUpdatePut,
  asnPost,
  asnSkuSampleGet,
  asnIdFilesSubmitPost,
  asnIdCommentsUploadPost,
  asnIdEventEventPut,
  asnIdValidatePackingListGet,
  asnIdSampleCommentDownloadGet,
  asnIdValidatePackingListOnUploadPost,
  asnIdUpdateFieldsPut,
  asnIdRequiredFilesGet
};
